import React, { useState, useEffect } from "react";
import { useCookies, withCookies } from "react-cookie";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import { useAuthCheck } from "../util/utils";

const SearchUserComponent = ({ api }) => {
  const navigate = useNavigate()
  const [cookies] = useCookies(['token'])
  console.log('SearchUsers - cookies:', cookies)
  console.log('SearchUsers - token:', cookies.token)
  console.log('SearchUsers - all cookie keys:', Object.keys(cookies))
  const [query, setQuery] = useState(""); // User input
  const [recs, setRecs] = useState([])
  const [results, setResults] = useState([]); // Search results
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [debouncedQuery, setDebouncedQuery] = useState(query); // Debounced query

  // Debounce effect: Update the debounced query after 500ms of no input changes
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedQuery(query), 500);
    return () => clearTimeout(handler); // Cleanup timeout on query change
  }, [query]);

  useEffect(() => {
    (async () => {
      if (!cookies.token) return
      try {
        console.log(`token is ${cookies.token}`)
        const resp = await api().getFollowRecs(cookies.token)
        if (resp.status === 200) {
          setRecs(resp.data)
        }
      } catch (e) {
        console.log(e)
      }
    })()
  }, [cookies.token])

  // Fetch users whenever the debouncedQuery changes
  useEffect(() => {
    if (debouncedQuery.trim() === "") {
      setResults([]);
      return;
    }

    const fetchUsers = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api().searchUsers(cookies.token, debouncedQuery)
        if (response.status === 200) {

          setResults(response.data);
        }
      } catch (err) {
        setError("Failed to fetch users. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [debouncedQuery, cookies.token]);

  return (
    <div className="bg-gradient-to-b from-blue-400 to-green-700 min-h-screen pt-20 p-4 flex justify-center">
      <div className="w-full md:w-1/2">
        {/* Search Box */}
        <div className="mb-4">
          <input
            type="text"
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Search for users..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        {/* Loading Spinner */}
        {loading && <p className="text-blue-500">Searching...</p>}

        {/* Error Message */}
        {error && <p className="text-red-500">{error}</p>}

        {/* Results */}
        <ul className="space-y-4">
          {results.map((user) => (
            <li
              key={user._id}
              className="flex items-center space-x-4 p-4 bg-gray-100 hover:bg-opacity-75 bg-opacity-50 rounded-lg shadow-md"
              onClick={() => navigate(`/user/${user.username}`)}
            >
              {/* Placeholder avatar */}
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-500 text-white font-bold">
                {user.firstName.charAt(0)}
                {user.lastName.charAt(0)}
              </div>
              {/* User details */}
              <div>
                <p className="text-lg font-semibold">
                  {user.firstName} {user.lastName}
                </p>
                <p className="text-sm text-gray-500">{user.username}</p>
              </div>
            </li>
          ))}
        </ul>

        {/* No Results */}
        {!loading && !error && results.length === 0 && debouncedQuery.trim() !== "" && (
          <p className="text-white pb-4 text-lg font-semibold">No users found. Try looking for something else</p>
        )}
        {/* No Results */}
        {results.length == 0 && recs && (
          <ul className="space-y-4">
            <p className="text-white text-lg font-semibold">People you may know</p>
            {results.length == 0 && recs && recs.map((user) => (
              <li
                key={user._id}
                className="flex items-center space-x-4 p-4 bg-gray-100 hover:bg-opacity-75 bg-opacity-50 rounded-lg shadow-md"
                onClick={() => navigate(`/user/${user.username}`)}
              >
                {/* Placeholder avatar */}
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-500 text-white font-bold">
                  {user.firstName.charAt(0)}
                  {user.lastName.charAt(0)}
                </div>
                {/* User details */}
                <div>
                  <p className="text-lg font-semibold">
                    {user.firstName} {user.lastName}
                  </p>
                  <p className="text-sm text-gray-500">{user.username}</p>
                </div>
              </li>
            ))}
          </ul>
        )
        }
      </div>
    </div>
  );
};

const SearchUsers = withCookies(({ api }) => (
  <div>
    <Header api={api} />
    <SearchUserComponent api={api} />
  </div>
))

export default SearchUsers;